import { render, staticRenderFns } from "./MonthMrp.vue?vue&type=template&id=28e0c5ac&"
import script from "./MonthMrp.vue?vue&type=script&lang=js&"
export * from "./MonthMrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports